import { Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
const GoogleButton = ({ onClick}) => {
  const theme = useTheme();
  const location = useLocation();
  return (
    <Box>
      <Button
        onClick={onClick}
        fullWidth
        variant="outlined"
        size="large"
        startIcon={
          <img
            src="https://www.cdnlogo.com/logos/g/35/google-icon.svg"
            alt="google"
            style={{ height: "35px" }}
          />
        }
        sx={{
          backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : 'white',
          color: theme.palette.text.primary,
          borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey[300],
          mb: 1,
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' 
              ? theme.palette.background.default 
              : theme.palette.grey[100],
            borderColor: theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey[400],
            
          },
        }}
      >
        <Typography marginX={2}>{location.pathname === "/signup" ? "Sign up" : "Login"} with Google</Typography>
      </Button>
    </Box>
  );
};

export default GoogleButton;